// saga.ts
import { call, put, takeLatest } from 'redux-saga/effects';
import { assetAllocatorActions as actions } from '.';
import { PayloadAction } from '@reduxjs/toolkit';
import { authenticatedGet } from 'remote/api';
import { GoalData, AssetAllocation, AssetResponse } from './types';

const ASSET_ENDPOINTS: Record<string, string> = {
  forex: '/currencies',
  crypto: '/cryptos',
  equity: '/equities',
};

function* fetchGoalsSaga() {
  try {
    const response: { data: { data: GoalData[] } } = yield call(
      authenticatedGet,
      `${process.env.REACT_APP_API_URL}/goals`,
    );
    yield put(actions.fetchGoalsSuccess(response.data.data));
  } catch (error: any) {
    yield put(
      actions.fetchGoalsFailed(error?.message || 'Failed to fetch goals'),
    );
  }
}

function* fetchAllocationsSaga(action: PayloadAction<string>) {
  try {
    const goalId = action.payload;
    const response: { data: { data: AssetAllocation[] } } = yield call(
      authenticatedGet,
      `${process.env.REACT_APP_API_URL}/allocations?goal_id=${goalId}`,
    );
    yield put(actions.fetchAllocationsSuccess(response.data.data));
  } catch (error: any) {
    yield put(
      actions.fetchAllocationsFailed(
        error?.message || 'Failed to fetch allocations',
      ),
    );
  }
}

function* fetchAssetsSaga(action: PayloadAction<string>) {
  try {
    const assetType = action.payload;
    const endpoint = ASSET_ENDPOINTS[assetType] || '/equities';

    const response: { data: AssetResponse } = yield call(
      authenticatedGet,
      `${process.env.REACT_APP_API_URL}${endpoint}`,
    );

    yield put(actions.fetchAssetsSuccess(response.data));
  } catch (error: any) {
    yield put(
      actions.fetchAssetsFailed(error?.message || 'Failed to fetch assets'),
    );
  }
}

export function* watchAssetAllocatorSaga() {
  yield takeLatest(actions.fetchGoals.type, fetchGoalsSaga);
  yield takeLatest(actions.fetchAllocations.type, fetchAllocationsSaga);
  yield takeLatest(actions.fetchAssets.type, fetchAssetsSaga);
}
